import IndexNavbar from 'components/Navbars/IndexNavbar'
import React from 'react'

const VideoDownloaderPrivacy = () => {
    React.useEffect(() => {
        document.body.classList.add("index-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        return function cleanup() {
            document.body.classList.remove("index-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            <div className="wrapper">
                <div className="main">
                    <div className="policy-wrapper">
                        <div className="policy-container">
                            <header className="policy-header">
                                <h1>Privacy Policy for MediaHD Downloader</h1>
                                <p className="effective-date">Effective Date: 01 October 2024</p>
                            </header>

                            <nav className="table-of-contents">
                                <h2>Table of Contents</h2>
                                <ul>
                                    <li><a href="#section1">1. Information We Collect</a></li>
                                    <li><a href="#section2">2. How We Use Your Information</a></li>
                                    <li><a href="#section3">3. Sharing Your Information</a></li>
                                    <li><a href="#section4">4. Data Security</a></li>
                                    <li><a href="#section5">5. Your Rights and Choices</a></li>
                                    <li><a href="#section6">6. Data Retention</a></li>
                                    <li><a href="#section7">7. Children&apos;s Privacy</a></li>
                                    <li><a href="#section8">8. International Transfers</a></li>
                                    <li><a href="#section9">9. Changes to This Privacy Policy</a></li>
                                    <li><a href="#section10">10. Contact Us</a></li>
                                </ul>
                            </nav>

                            <section>
                                <p>
                                    CRYPTO FINANCIAL SOLUTION CO., LTD (&quot;Company,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and share information when you use the MediaHD Downloader mobile application (&quot;App&quot;), which allows users to download videos from supported websites.
                                </p>
                                <p className="alert-box">
                                    <strong>Important:</strong> By using MediaHD Downloader, you agree to the practices outlined in this Privacy Policy. If you do not agree with these practices, please do not use the App.
                                </p>
                            </section>

                            <section id="section1">
                                <h2>1. Information We Collect</h2>
                                <p>We collect the following types of information when you use MediaHD Downloader:</p>

                                <h3>Usage Data</h3>
                                <p>We automatically collect certain information when you interact with the App. This may include:</p>
                                <ul className="feature-list">
                                    <li>Device information (e.g., model, operating system, and unique device identifiers)</li>
                                    <li>IP address</li>
                                    <li>App usage data (e.g., how often and for how long you use the App)</li>
                                    <li>Performance data (e.g., app crashes or diagnostics)</li>
                                </ul>
                            </section>

                            <section id="section2">
                                <h2>2. How We Use Your Information</h2>
                                <p>We use the information we collect for various purposes, including:</p>
                                <ul className="feature-list">
                                    <li><strong>App Operation:</strong> To provide and maintain the App&apos;s functionality.</li>
                                    <li><strong>User Experience:</strong> To improve the App by analyzing user interactions and feedback.</li>
                                    <li><strong>Communications:</strong> To respond to your inquiries, provide customer support, and send you updates about the App.</li>
                                    <li><strong>Security:</strong> To monitor and improve the security of the App.</li>
                                    <li><strong>Legal Compliance:</strong> To comply with legal obligations or respond to lawful requests.</li>
                                </ul>
                            </section>

                            <section id="section3">
                                <h2>3. Sharing Your Information</h2>
                                <p>We do not sell or rent your personal information to third parties. However, we may share your information in the following cases:</p>
                                <ul className="feature-list">
                                    <li><strong>Service Providers:</strong> We may share your information with third-party service providers who assist us in operating the App (e.g., cloud hosting, analytics services). These providers are bound by confidentiality agreements and are not permitted to use your information for their own purposes.</li>
                                    <li><strong>Legal Obligations:</strong> We may disclose your information if required by law, court order, or government request, or if we believe it is necessary to protect our rights or the safety of others.</li>
                                    <li><strong>Business Transfers:</strong> If the Company undergoes a merger, acquisition, or asset sale, your information may be transferred as part of that transaction.</li>
                                </ul>
                            </section>

                            <section id="section4">
                                <h2>4. Data Security</h2>
                                <p>We implement reasonable security measures to protect your information from unauthorized access, disclosure, or loss. However, no method of electronic transmission or storage is entirely secure, and we cannot guarantee the absolute security of your data.</p>
                            </section>

                            <section id="section5">
                                <h2>5. Your Rights and Choices</h2>
                                <p>You have certain rights and choices regarding your personal information:</p>
                                <ul className="feature-list">
                                    <li><strong>Access and Correction:</strong> You may request access to or correction of your personal information by contacting us at admin@cryptofinancialsolution.com.</li>
                                    <li><strong>Data Deletion:</strong> You may request the deletion of your personal information by contacting us. Please note that we may retain certain information as required by law or for legitimate business purposes.</li>
                                    <li><strong>Opt-Out of Communications:</strong> If you no longer wish to receive marketing communications from us, you can opt out by following the unsubscribe instructions in those emails or contacting us directly.</li>
                                </ul>
                            </section>

                            <section id="section6">
                                <h2>6. Data Retention</h2>
                                <p>We will retain your personal information only for as long as necessary to provide the App&apos;s services and for legitimate business or legal purposes. Usage data may be retained for longer periods for analysis and internal record-keeping.</p>
                            </section>

                            <section id="section7">
                                <h2>7. Children&apos;s Privacy</h2>
                                <p>The App is not intended for children under the age of 13. We do not knowingly collect personal information from children. If we learn that we have collected personal information from a child under 13 without parental consent, we will take steps to delete that information.</p>
                            </section>

                            <section id="section8">
                                <h2>8. International Transfers</h2>
                                <p>If you are located outside of Vietnam, please note that your information may be transferred to and processed in a country other than your own. By using the App, you consent to the transfer and processing of your information in accordance with this Privacy Policy.</p>
                            </section>

                            <section id="section9">
                                <h2>9. Changes to This Privacy Policy</h2>
                                <p>We may update this Privacy Policy from time to time to reflect changes in our practices or the App&apos;s features. We will notify you of any significant changes by posting the updated policy within the App or through other communication methods. Your continued use of the App after such changes constitutes your acceptance of the updated Privacy Policy.</p>
                            </section>

                            <section id="section10">
                                <h2>10. Contact Us</h2>
                                <p>If you have any questions or concerns about this Privacy Policy or how we handle your personal information, please contact us at:</p>
                                <ul className="feature-list">
                                    <li>Email: <a href="mailto:admin@cryptofinancialsolution.com" className="email-link">admin@cryptofinancialsolution.com</a></li>
                                    <li>Address: 255 Nguyen Van Troi, Ha Dong District, Hanoi, Vietnam.</li>
                                </ul>
                            </section>

                            <footer className="terms-footer">
                                <p>By using MediaHD Downloader, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.</p>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VideoDownloaderPrivacy;
